import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import { VERIFY_AUTH, PURGE_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import JwtService from "@/core/services/jwt.service";
import jwt_decode from "jwt-decode";
import VueLazyload from "vue-lazyload";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "https://d604u3cjqmj8m.cloudfront.net/resources/images/no-photo.png",
  attempt: 1,
  // listenEvents: ["scroll"],
  lazyComponent: true
});

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "./common/mixin";

// API service init
ApiService.init();

router.beforeEach((to, from, next) => {
  if (JwtService.getToken()) {
    var { account_id } = jwt_decode(JwtService.getToken());
    if (account_id) {
      Promise.all([store.dispatch(VERIFY_AUTH, account_id)]).then(next);
    }
  } else {
    store.commit(PURGE_AUTH);
    next();
  }

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
